import { computed, type MaybeRef, ref, useAttrs } from 'vue';

export const useDataTestid = (dataTestid?: MaybeRef<string | undefined>) => {
  const attrs = useAttrs();
  const refDataTestId = ref(dataTestid);
  const internalDataTestid = computed(
    () => (attrs['data-testid'] as string) ?? refDataTestId.value ?? (attrs.id as string),
  );
  const suffix = (suffix: string) =>
    internalDataTestid.value ? `${internalDataTestid.value}-${suffix}` : undefined;

  return { dataTestid: internalDataTestid, suffix };
};
